import { buildReceiptPdfSummary } from './receiptPdfSummary';

export const createDocDefinitionDotStyle = ({
    printType,
    documentType,
    documentNumber,
    company,
    receipt,
    logoBase64,
    totalAmount,
    paidAmount,
    remainingAmount,
    numberToThaiText,
    formatCurrency,
    dayjs
}) => {
    const summary = buildReceiptPdfSummary(receipt);
    const showTaxBreakdown = summary.vatMode !== 'no_vat' || summary.taxAmount > 0;
    const pdfTotalAmount = summary.grandTotal || totalAmount;

    return {
    pageSize: 'A4',
    pageMargins: [23, 60, 23, 30], //left, top, right, bottom
    defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 16,
        lineHeight: 0.9   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
    },
    styles: {
        header: {
            fontSize: 25,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
        },
        subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
        },
        tableHeader: {
            bold: true,
            fontSize: 15,
            color: 'black',
            fillColor: '#eeeeee'
        },
        total: {
            fontSize: 16,
            bold: true,
            alignment: 'right'
        },
        paid: {
            fontSize: 16,
            bold: true,
            color: '#52c41a'
        },
        overdue: {
            fontSize: 16,
            bold: true,
            color: '#cf1322'
        }
    },
    content: [
        // หัวข้อเอกสาร
        {
            text: printType === 'full' ? documentType : '',
            style: 'header',
            alignment: 'right'
        },

        // =============================
        // ส่วนข้อมูลบริษัท (มีพื้นหลังฟ้าอ่อน)
        // =============================
        {
            table: {
                widths: ['60%', '40%'],
                body: [
                    [
                        {
                            columns: [
                                {
                                    ...(logoBase64
                                        ? { image: logoBase64, width: 80, alignment: 'left', margin: [0, 18, 0, 0] }
                                        : { text: '', fontSize: 18, bold: true, margin: [0, 18, 0, 0] }
                                    ),
                                },
                                {
                                    stack: [
                                        { text: company.company_name || 'ชื่อบริษัท', bold: true, fontSize: 16 },
                                        { text: company.address || 'ที่อยู่บริษัท', margin: [0, 0, 0, 0] },
                                        { text: `โทรศัพท์: ${company.phone || 'หมายเลขโทรศัพท์'}`, margin: [0, 0, 0, 0] }
                                    ],
                                    margin: [10, 10, 0, 10]
                                },
                            ],
                            border: [false, false, false, false],
                            margin: [0, -65, 0, 10]
                        },
                        {
                            stack: [
                                {
                                    canvas: [
                                        {
                                            type: 'rect',
                                            x: 0,
                                            y: 0,
                                            w: 160, // กำหนดความกว้างของพื้นหลัง (ปรับได้)
                                            h: 50,  // กำหนดความสูงของพื้นหลัง (พอดีข้อความ)
                                            r: 10,  // ความมนของขอบ 10px
                                            color: '#E3F2FD' // 💙 สีฟ้าอ่อน
                                        }
                                    ],
                                    absolutePosition: { x: 350, y: 97 }, // ปรับตำแหน่งตาม layout ของคุณ
                                },
                                {
                                    text: [
                                        { text: printType === 'full' ? 'เลขที่เอกสาร: ' : '', bold: true },
                                        { text: documentNumber || '-', bold: false },

                                    ],
                                    margin: [0, 0, 20, 0],
                                },
                                {
                                    text: [
                                        { text: printType === 'full' ? 'วันที่: ' : '', bold: true },
                                        { text: dayjs(receipt.receipt_date).format('DD/MM/YYYY'), bold: false }
                                    ],
                                    margin: [0, 0, 20, 0],
                                },
                                // ถ้าต้องการเพิ่มวันหมดอายุ uncomment ตรงนี้
                                // {
                                //   text: [
                                //     { text: 'วันหมดอายุ: ', bold: true },
                                //     { text: dayjs(quote.validUntil).format('DD/MM/YYYY'), bold: false }
                                //   ],
                                //   margin: [0, 2, 0, 0]
                                // }
                            ],
                            alignment: 'right',
                            border: [false, false, false, false],
                            margin: [0, 18, 0, 0]
                        }
                    ]
                ]
            },
            margin: [0, 0, 0, 0]
        },

        // ข้อมูลลูกค้า
        // {
        //     text: 'ข้อมูลลูกค้า',
        //     style: 'subheader'
        // },
        {
            lineHeight: 0.8,
            fontSize: 15,
            text: [
                { text: 'ชื่อลูกค้า: ', bold: true },
                receipt.company_name || '-',
                '\n',
                { text: 'ที่อยู่: ', bold: true },
                receipt.address || '-',
                '\n',
                { text: 'โทรศัพท์: ', bold: true },
                receipt.phone || '-',
                // '\n',
                // { text: 'อีเมล: ', bold: true },
                // receipt.email || '-',
                '\n',
                { text: 'เลขที่ภาษี: ', bold: true },
                receipt.tax_id || '-'

            ],
            margin: [10, -25, 0, 68]
        },

        // รายการสินค้า/บริการ
        // {
        //     text: 'รายการสินค้า/บริการ',
        //     style: 'subheader'
        // },
        {
            table: {
                headerRows: 0,
                widths: [26, 69, 232, 52, 55, 65],
                body: [
                    [
                        { text: '', style: 'tableHeader', alignment: 'center' },
                        { text: '', style: 'tableHeader', alignment: 'center' },
                        { text: '', style: 'tableHeader', alignment: 'center' },
                        { text: '', style: 'tableHeader', alignment: 'center' },
                        { text: '', style: 'tableHeader', alignment: 'center' },
                        { text: '', style: 'tableHeader', alignment: 'center' }
                    ],
                    ...(receipt.items || []).map((item, index) => [
                        { text: (index + 1).toString(), alignment: 'right' }, // ✅ ลำดับที่
                        { text: item.barcode || '-', alignment: 'center' },
                        { text: item.description || '-', alignment: 'center' },
                        { text: item.quantity?.toString() || '0', alignment: 'center' },
                        { text: `${(item.unit_price || 0).toLocaleString()} `, alignment: 'right' },
                        { text: `${(item.total_price || 0).toLocaleString()} `, alignment: 'right' }
                    ])
                ]
            },
            // layout: {
            //     fillColor: function (rowIndex, node, columnIndex) {
            //         return (rowIndex === 0) ? '#eeeeee' : null;
            //     }
            // },
            layout: 'noBorders',
            margin: [0, 0, 0, 20]
        },
        // วิธีการชำระเงิน
        // ...(receipt.payment_method ? [{
        //     text: 'วิธีการชำระเงิน',
        //     style: 'subheader',
        //     margin: [0, 5, 0, 0]
        // }, {
        //     text: receipt.payment_method,
        //     margin: [0, 0, 0, 5]
        // }] : []),

        // หมายเหตุ
        ...(receipt.notes ? [{
            text: 'หมายเหตุ',
            style: 'subheader',
            margin: [0, 5, 0, 0]
        }, {
            text: receipt.notes,
            margin: [0, 0, 0, 5]
        }] : []),


    ], //ส่วนท้ายกระดาษ (แสดงหน้าสุดท้ายของเอกสาร)
    footer: function (currentPage, pageCount) {
        if (currentPage !== pageCount) return {}; // แสดงเฉพาะหน้าสุดท้าย

        return {
            margin: [40, -185, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
            lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
            stack: [
                // ยอดรวม
                {
                    columns: [
                        {
                            lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                            width: '78%',
                            style: 'bathText',
                            stack: [
                                // เงื่อนไขการชำระเงิน (สำหรับใบแจ้งหนี้)
                                {
                                    text: 'เงื่อนไขการชำระเงิน',
                                    style: 'subheader',
                                    margin: [0, 10, 0, 5]
                                },
                                {
                                    text: `- กรุณาชำระเงินตามกำหนดเวลาที่ระบุไว้ หากมีข้อสงสัยกรุณาติดต่อกลับ`,
                                    margin: [15, 0, 0, 21]

                                },
                                //ตัวหนังสือใบเสร็จ
                                {
                                    text: `${numberToThaiText(pdfTotalAmount)}`,
                                    margin: [0, 8, 0, 0]
                                }
                            ],
                            margin: [5, 0, 40, 0], // Left, Top, Right, Bottom <— ดึงขึ้น (negative top margin สำคัญ)
                        },
                        // สรุปยอดเงิน
                        {
                            width: '22%',
                            lineHeight: 0.7, //ความสูงของแถว
                            table: {
                                body: [
                                    // ✅ ยอดรวมก่อนภาษี (ยังไม่หักส่วนลด)
                                    [
                                        { text: '', alignment: 'right' },
                                        { text: `${formatCurrency(summary.grossAmount)}`, alignment: 'right', margin: [0, 0, 0, 0] },
                                    ],
                                    // ✅ ส่วนลด
                                    [
                                        { text: '', alignment: 'right' },
                                        { text: `${formatCurrency(summary.discountAmount)}`, alignment: 'right', margin: [0, 0, 0, 0] },
                                    ],
                                    // ✅ ✅ เพิ่มมา: ราคาไม่รวมภาษี (subtotal - discount)
                                    [
                                        { text: '', alignment: 'right', bold: true },
                                        {
                                            text: `${formatCurrency(summary.netAmount)}`,
                                            alignment: 'right',
                                            bold: true,
                                            margin: [0, 0, 0, 0]
                                        }
                                    ],
                                    ...(showTaxBreakdown ? [[
                                        { text: '', alignment: 'right' },
                                        { text: `${formatCurrency(summary.taxAmount)}`, alignment: 'right', margin: [0, 0, 0, 3] }
                                    ]] : []),
                                    // ✅ ยอดรวมทั้งสิ้น
                                    [
                                        { text: '', bold: true, alignment: 'right' },
                                        { text: `${formatCurrency(pdfTotalAmount)}`, bold: true, alignment: 'right', margin: [0, 0, 0, 0] }
                                    ],
                                ]
                            },
                            layout: 'noBorders',
                            margin: [78, 0, 0, 0]
                        }
                    ],
                    margin: [0, -5, 0, 20]
                },

                // ลายเซ็น
                // {
                //     columns: [
                //         {
                //             width: '50%',
                //             text: [
                //                 'ลงชื่อ ......................................',
                //                 '\n\n',
                //                 '(                                            )',
                //                 '\n',
                //                 receipt.status === 'paid' ? 'ผู้รับเงิน' : 'ผู้ออกเอกสาร'
                //             ],
                //             alignment: 'center'
                //         },
                //         {
                //             width: '50%',
                //             text: [
                //                 'ลงชื่อ ......................................',
                //                 '\n\n',
                //                 '(                                            )',
                //                 '\n',
                //                 receipt.status === 'paid' ? 'ผู้จ่ายเงิน' : 'ผู้รับเอกสาร'
                //             ],
                //             alignment: 'center'
                //         }
                //     ]
                // }
            ]
        };
    }
    };
};
